<summary-card
    cardTitle="PAGES.BUILDING_HOME.TOP_ACTIONS"
    helpLink="plans-action-vue-globale"
    [summaryList]="actionList"
    [action]="actionListAction"
    [noDataMessage]="actionNoDataInfo$ | async"
    [rightNeeded]="rightNeeded"
    [isLoading]="isLoading"
    [hasError]="loadingError"
/>
